module.exports = __webpack_public_path__ + "img/vertical_6_3_6000.b54f656b.png";